import type { Styles } from 'common/types';

export const styles: Styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    p: 2.5,
    borderRadius: '16px',
    border: '2px solid',
    borderColor: 'divider',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease-in-out',
    position: 'relative',
    flexGrow: 1,
    cursor: 'pointer',
    '&:hover': {
      borderColor: 'primary.light',
    },
  },
  cardSelected: {
    borderColor: 'primary.main',
    boxShadow: 'none',
    '&:hover': {
      borderColor: 'primary.main',
      boxShadow: 'none',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 1,
    mb: 2,
  },
  stickerInput: {
    flexGrow: 1,
    '& .MuiInputBase-root': { borderRadius: 2 },
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      top: '100%',
      marginLeft: 0,
      marginTop: '2px',
      whiteSpace: 'nowrap',
      lineHeight: 1.2,
    },
  },
  imageContainer: {
    width: '100%',
    height: 140,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    mb: 2,
    p: 1,
  },
  image: {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 1.5,
  },
  marketplaceLogo: {
    width: 20,
    height: 20,
    objectFit: 'contain',
  },
  asinContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    cursor: 'pointer',
    color: 'text.secondary',
    p: 0.5,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: 'action.hover',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: 'primary.main',
      borderColor: 'primary.main',
    },
  },
  asinText: {
    fontSize: '0.8rem',
    fontFamily: 'monospace',
    fontWeight: 500,
  },
  linkedProductContainer: {
    mb: 2,
    p: 1.5,
    borderRadius: '8px',
    backgroundColor: '#f8fafd',
    border: '1px dashed',
    borderColor: 'divider',
  },
  linkedProductHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    mb: 1,
  },
  linkedMarketplaceIcon: {
    width: 16,
    height: 16,
    objectFit: 'contain',
  },
  linkedInputWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
  },
  linkedSuccessBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#f0fdf4',
    border: '1px solid',
    borderColor: '#bbf7d0',
    p: 1,
    px: 1.5,
    borderRadius: '6px',
  },
  titleContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    mb: 2.5,
  },
  titleInput: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    '& .MuiInputBase-root': {
      fontSize: '0.875rem',
      alignItems: 'flex-start',
      p: 1.5,
      height: '100%',
    },
    '& textarea': {
      resize: 'none',
      height: '100% !important',
      overflowY: 'auto !important',
      '&::-webkit-scrollbar': { width: '4px' },
      '&::-webkit-scrollbar-track': { background: 'transparent' },
      '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: '4px' },
    },
  },
  charCount: {
    position: 'absolute',
    bottom: -18,
    right: 4,
    fontSize: '0.7rem',
  },
  actionsStack: {
    mt: 'auto',
    pt: 2,
  },
  actionBtnPartner: {
    borderRadius: 2,
    textTransform: 'none',
    '& .MuiButton-startIcon': {
      marginRight: 1,
    },
  },
  attributionSourceIcon: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    height: 16,
    justifyContent: 'center',
    overflow: 'hidden',
    width: 16,
    '& img, & svg': {
      display: 'block',
      height: 16,
      maxHeight: 16,
      maxWidth: 16,
      objectFit: 'contain',
      width: 16,
    },
  },
  actionBtnReplace: {
    textTransform: 'none',
    color: 'text.secondary',
    transition: 'all 0.2s ease-in-out',
    borderRadius: 2,
    '&:hover': {
      backgroundColor: 'error.50',
      color: 'error.main',
      '& .MuiButton-startIcon': { color: 'error.main' },
    },
  },
};
